import Vue from 'vue'
import Vuex from 'vuex'

import state from "./state"
import getters from "./getters"
import actions from "./actions"
import mutations from "./mutations"

Vue.use(Vuex)

// import moduleTodo from './todo/moduleTodo.js'
// import moduleCalendar from './calendar/moduleCalendar.js'
import moduleChat from './chat/moduleChat.js'
// import moduleEmail from './email/moduleEmail.js'
import moduleAuth from './auth/moduleAuth.js'
import moduleECommerce from './eCommerce/moduleECommerce.js'
import global from './modules/global'
import users from './modules/users'
import tenants from './modules/tenants'
import connections from './modules/connections'
import permission from './modules/permission'
import report from './modules/report'

export default new Vuex.Store({
    getters,
    mutations,
    state,
    actions,
    modules: {
        // todo: moduleTodo,
        // calendar: moduleCalendar,
        chat: moduleChat,
        // email: moduleEmail,
        auth: moduleAuth,
        eCommerce: moduleECommerce,
        global,
        users,
        tenants,
        connections,
        permission,
        report
    },
    strict: process.env.NODE_ENV !== 'production'
})
